import { Box, Skeleton, type SkeletonProps, Stack } from '@mui/material';
import Fields2 from '/@/components/icon/assets/fields2.svg';

function FieldSkeleton({ skeletonProps }: { skeletonProps?: SkeletonProps }) {
    return (
        <Stack direction='row' spacing={2} p={2} width='100%' alignItems='center'>
            <Box
                sx={{
                    width: '36px',
                    height: '36px',
                }}
            >
                <img src={Fields2} alt='fields2' />
            </Box>
            <Stack width='100%'>
                <Skeleton variant='text' width='40%' {...skeletonProps} />
                <Skeleton variant='text' width='70%' {...skeletonProps} />
            </Stack>
        </Stack>
    );
}

export default FieldSkeleton;
